import React, { FC, useContext, useState } from 'react';

import {
  Button,
  H3,
  Input,
  NumberInput,
  Select,
  Tooltip,
} from '@smartshell/ui-kit';
import { Controller } from 'react-hook-form';

import { LocalizationContext } from 'localization';
import { EPromoCampaignGenerationType } from 'types';

import { GeneratePromoModal } from '../GeneratePromoModal';
import s from './FormComponents.module.scss';
import { IFormComponentsProps } from './interfaces';

export const Generate: FC<IFormComponentsProps> = ({ control, id, action }) => {
  const { t } = useContext(LocalizationContext);

  const SYMBOLS_OPTIONS = [
    { title: '6', value: 6 },
    { title: '7', value: 7 },
    { title: '8', value: 8 },
  ];
  const FORMAT_OPTIONS = [
    {
      title: t('promo_group.generate.mask_1'),
      value: EPromoCampaignGenerationType.MIXED,
    },
    {
      title: t('promo_group.generate.mask_2'),
      value: EPromoCampaignGenerationType.SYMBOLS,
    },
    {
      title: t('promo_group.generate.mask_3'),
      value: EPromoCampaignGenerationType.NUMERIC,
    },
  ];

  const [openGenerate, setOpenGenerate] = useState<boolean>(false);

  return (
    <>
      {openGenerate && (
        <GeneratePromoModal onClose={() => setOpenGenerate(false)} id={id} />
      )}
      <div className={s.frame}>
        <div className={s.header}>
          <H3>{t('promo_group.generate')}</H3>
          {id && !action && (
            <Button
              iconName="CirclePlusIcon"
              variant="secondary"
              className={s.button}
              onClick={() => setOpenGenerate(true)}
            >
              {t('promo.generate.add')}
            </Button>
          )}
        </div>
        <div className={s.flex}>
          <Controller
            render={({ field: { name, ...field }, fieldState: { error } }) => (
              <NumberInput
                {...field}
                title={t('promo.generate.count')}
                error={error?.message}
                bordered
                disabled={Boolean(id) && !action}
                rightContent={
                  <Tooltip
                    contentClassName={s.tooltip}
                    content={t('promo_campaign.generating.amount.tooltip')}
                  />
                }
              />
            )}
            name="codesCount"
            control={control}
            rules={{
              required: t('errors.required'),
              min: {
                value: 1,
                message: t('errors.min', 1),
              },
              max: {
                value: 1000,
                message: t('errors.max', 1000),
              },
            }}
          />
          <Controller
            render={({ field: { name, ...field }, fieldState: { error } }) => (
              <Select
                name="amount_symbols"
                options={SYMBOLS_OPTIONS}
                {...field}
                title={t('promo_group.generate.symbols')}
                error={error?.message}
                bordered
                disabled={Boolean(id) && !action}
              />
            )}
            name="codeLength"
            control={control}
            rules={{
              required: t('errors.required'),
            }}
          />
        </div>

        <div className={s.flex}>
          <Controller
            render={({ field: { name, ...field }, fieldState: { error } }) => (
              <Input
                {...field}
                value={field.value || ''}
                title={t('promo.generate.prefix')}
                error={error?.message}
                bordered
                rightContent={
                  <Tooltip
                    contentClassName={s.tooltip}
                    content={t('promo_group.generate.prefix.tooltip')}
                  />
                }
                disabled={Boolean(id) && !action}
              />
            )}
            name="prefix"
            control={control}
            rules={{
              minLength: {
                value: 2,
                message: t('errors.minLength', 2),
              },
              maxLength: {
                value: 6,
                message: t('errors.maxLength', 6),
              },
            }}
          />
          <Controller
            render={({ field: { name, ...field }, fieldState: { error } }) => (
              <Select
                name="amount_symbols"
                options={FORMAT_OPTIONS}
                {...field}
                title={t('promo.generate.format')}
                error={error?.message}
                bordered
                disabled={Boolean(id) && !action}
              />
            )}
            name="format"
            control={control}
            rules={{
              required: t('errors.required'),
            }}
          />
        </div>
      </div>
    </>
  );
};
